import Repository from '@/repositories/Repository'
import WeatherWarningHistory from '@/models/WeatherWarningHistory'
import { encodeGetParams } from '@/lib/utils'

export type WeatherWarningHistoryParams = {
  areaCode: string
  range: {
    startTime: string
    endTime: string
  }
}

class WeatherWarningHistoryRepository extends Repository {
  constructor() {
    super('/weather-warning-history')
  }

  async get(params: WeatherWarningHistoryParams) {
    const query = encodeGetParams<WeatherWarningHistoryParams>(params)
    const attributes = await super._get(query)

    return new WeatherWarningHistory(attributes)
  }
}

export default WeatherWarningHistoryRepository
